import Grid from '../../../components/grid'
import Container from '../../../components/ui/container'
import Text from '../../../components/ui/text'
import { Asset } from '../../../v2/components/Asset'
import ModalForm from '../../components/ModalForm'
import { cn } from '@telesoft/lib/web/cn'
import { Asset as AssetType, Form, Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'
import { CMSLink } from '../../components/CMSLink'

export type GenericCTAProps = Extract<Page['blocks'][0], { blockType: 'generic-cta' }>

export default function GenericCTA(block: GenericCTAProps): ReactElement {
  const { title, description, link, options } = block
  const image = options?.image as AssetType
  const imageOpacity = options?.imageOpacity ?? null
  const CTAType = block.type

  return (
    <Container>
      <div
        className={`relative p-8 md:p-12 lg:p-20 flex flex-col justify-center items-center ${
          options.theme === 'dark' ? 'bg-black' : 'bg-accent-1'
        }`}
      >
        <div className="absolute inset-0 z-20 opacity-50 bg-gradient-to-r from-transparent to-telesoft mix-blend-soft-light" />
        <Asset
          fill
          resource={image}
          style={imageOpacity ? { opacity: `0.${imageOpacity / 10}` } : undefined}
          imgClassName={cn(`object-cover object-center z-10`, {
            'opacity-20': !imageOpacity,
          })}
        />
        <Grid className="gap-8 z-30">
          <div className="col-span-4">
            <Text
              variant="subHeading"
              className={`${options.theme === 'dark' ? 'text-white' : 'text-black'}`}
            >
              {title}
            </Text>
          </div>

          <div
            className={`col-span-4 lg:pt-2 pb-2 lg:mb-0 border-b ${
              options.theme === 'dark' ? 'border-white' : 'border-black'
            }`}
          >
            <Text
              variant="body"
              className={`${options.theme === 'dark' ? 'text-white' : 'text-black'}`}
            >
              {description}
            </Text>
          </div>

          <div className="col-span-4 flex items-end">
            {CTAType === 'form' ? (
              <ModalForm
                formMessage="Please fill in your information below."
                cmsForm={block.form as Form}
                buttonLabel={block.label}
                buttonProps={{
                  className: cn(`w-full`, {
                    'text-white': options.theme === 'dark',
                    'text-black': options.theme === 'light',
                  }),
                }}
              />
            ) : (
              <CMSLink
                {...link}
                className={cn(`w-full`, {
                  'text-white': options.theme === 'dark',
                  'text-black': options.theme === 'light',
                })}
              />
            )}
          </div>
        </Grid>
      </div>
    </Container>
  )
}
